export default {
  auction: {
      auctionName:'拍卖名称',
    tableText1:'起拍价',
    tableText2:'付余款时间',
    tableText3:'加价',
    tableText4:'是否已经付款',
    bond:'保证金',
  }
}



// WEBPACK FOOTER //
// ./src/language/auction-zh-cn.js